var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FormWrapper",
    {
      attrs: {
        title: "Website",
        body: "Add a personal/demo website to your profile",
      },
    },
    [
      _c("ValidationObserver", {
        ref: "observer",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c("ValidationProvider", {
                  attrs: { rules: "url" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ errors }) {
                          return [
                            _c("FormGroup", {
                              staticClass: "mt-6",
                              attrs: {
                                name: "website",
                                title: "Website URL",
                                placeholder: "URL here",
                                errors: errors,
                              },
                              model: {
                                value: _vm.website,
                                callback: function ($$v) {
                                  _vm.website = $$v
                                },
                                expression: "website",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c(
                  "div",
                  { staticClass: "flex justify-end mt-2 pt-3 space-x-4" },
                  [
                    _vm.initialWebsiteValue
                      ? _c("UiButton", {
                          attrs: {
                            variant: "outline",
                            buttonText: "Delete",
                            disabled: _vm.fetching || _vm.updating,
                            processing: _vm.deleting,
                          },
                          on: { click: _vm.removeWebsite },
                        })
                      : _vm._e(),
                    _c("UiButton", {
                      attrs: {
                        buttonText: "Save",
                        variant: "black",
                        disabled: _vm.fetching || _vm.deleting,
                        processing: _vm.updating,
                      },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.updateWebsite)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }